import partial from './partial.js';
import before from './before.js';

// Returns a function that will be executed at most one time, no matter how
// often you call it. Useful for lazy initialization.
export default partial(before, 2);



//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/once.js
// module id = 1350
// module chunks = 9